import React from 'react'
import styled from 'styled-components'

import { media } from 'styles/media'
import IconDetail from 'components/display/FulfillingMoment/Icon/IconDetail'
import type { FulfillingMomentName } from 'components/display/FulfillingMoment/types'
import { ParagraphXs, ParagraphSm } from 'components/display/Typography'
import SimpleA from 'components/display/SimpleAnchor'
import { Section, SectionTitle } from './shared'

const MomentsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-top: 16px;

  ${media.md`
    gap: 24px;
    margin-top: 24px;
  `}
`

const Moment = styled.div`
  background-color: ${({ theme }) => theme?.['-ds-neutral-200']?.value};
  border-radius: 8px;
  padding: 8px 6px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  text-align: center;
  justify-content: center;

  ${media.md`
    padding: 16px;
  `}

  ${media.lg`
    flex-direction: row;
    text-align: left;
    justify-content: flex-start;
  `}

  svg {
    max-width: 45px;
    width: 100%;

    ${media.lg`
      max-width: 30px;
    `}

    ${media.xl`
      max-width: 37px;
    `}
  }

  ${ParagraphXs} {
    font-weight: 500;
    margin: 8px 0 0 0;
    hyphens: auto;
    word-break: break-word;

    ${media.lg`
        width: calc(100% - 37px);
        padding-left: 8px;
        margin: 0;
    `}

    ${media.xl`
      padding-left: 16px;
    `}
  }
`

interface ListingTopMomentsProps {
  moments: {
    name: string
    slug: string
    count: number
  }[]
}

const ListingTopMoments = ({ moments }: ListingTopMomentsProps) => {
  const topMoments = moments?.filter((moment) => moment.count > 2)?.slice(0, 3)

  return (
    topMoments?.length > 0 && (
      <Section
        // @ts-ignore -- not typed yet
        borderTop
      >
        <SectionTitle style={{ marginBottom: '16px' }}>
          Finding fulfillment
        </SectionTitle>
        <ParagraphSm style={{ maxWidth: '750px' }}>
          Based on traveller reviews, these are the top fulfilling moments
          experienced while staying here.{' '}
          <SimpleA href="/about" target="_blank">
            Learn more
          </SimpleA>
        </ParagraphSm>
        <MomentsWrapper>
          {topMoments.map((moment) => (
            <Moment key={moment.slug}>
              <IconDetail
                momentName={moment.name.toLowerCase() as FulfillingMomentName}
              />
              <ParagraphXs>{moment.name}</ParagraphXs>
            </Moment>
          ))}
        </MomentsWrapper>
      </Section>
    )
  )
}

export default ListingTopMoments
